import * as React from 'react';
import styles from './checkbox.module.css';

export interface CheckboxProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    indeterminate?: boolean;
    label?: React.ReactNode;
    disabled?: boolean;
    testId?: string;
    'aria-label'?: string;
    id?: string;
    name?: string;
    className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
    checked,
    onChange,
    indeterminate = false,
    label,
    disabled = false,
    testId,
    id,
    name,
    className,
    ...rest
}) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = !checked && indeterminate;
        }
    }, [checked, indeterminate]);

    const input = (
        <input
            ref={inputRef}
            type="checkbox"
            id={id}
            name={name}
            className={styles['input']}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            data-testid={testId}
            aria-label={rest['aria-label']}
        />
    );

    if (label === undefined) {
        return input;
    }

    return (
        <label className={[styles['root'], className].filter(Boolean).join(' ')}>
            {input}
            {label}
        </label>
    );
};
